import { render, staticRenderFns } from "./SkupSuorganizatorCreate.vue?vue&type=template&id=2e7beb9a&scoped=true&"
import script from "./SkupSuorganizatorCreate.vue?vue&type=script&lang=js&"
export * from "./SkupSuorganizatorCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7beb9a",
  null
  
)

export default component.exports